import * as React from "react";

const SvgComponent = (props) => (
    <svg width="18" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2936_26698)">
            <path d="M10.125 3.81445H4.29167C3.84964 3.81445 3.42572 3.99005 3.11316 4.30261C2.80059 4.61517 2.625 5.03909 2.625 5.48112V17.1478C2.625 17.5898 2.80059 18.0137 3.11316 18.3263C3.42572 18.6389 3.84964 18.8145 4.29167 18.8145H15.9583C16.4004 18.8145 16.8243 18.6389 17.1368 18.3263C17.4494 18.0137 17.625 17.5898 17.625 17.1478V11.3145" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.375 2.56464C16.7065 2.23312 17.1562 2.04687 17.625 2.04688C18.0938 2.04688 18.5435 2.23312 18.875 2.56464C19.2065 2.89616 19.3928 3.3458 19.3928 3.81464C19.3928 4.28348 19.2065 4.73312 18.875 5.06464L10.9583 12.9813L7.625 13.8146L8.45833 10.4813L16.375 2.56464Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_2936_26698">
                <rect width="20" height="20" fill="white" transform="translate(0.953125 0.668945)" />
            </clipPath>
        </defs>
    </svg>

);

export default SvgComponent;